import { ItemKind } from '../../../constants/ItemKind';
import { normalizeUri } from '../../../utils/utils';
import { SitesVisibility, sourceName as source, TeamAvailability } from '../constants';
import { decodeBoardId, encodeBoardId } from '../utils';
export const toBoard = data => ({
  id: encodeBoardId(data.board_id),
  parentId: 'boards',
  kind: ItemKind.Board,
  source,
  sitesVisibility: data.visibility || SitesVisibility.All,
  userId: data.user_id,
  siteId: data.site_id,
  name: data.title,
  description: data.description,
  thumbnailUrl: data.cover_url ? normalizeUri(data.cover_url) : null,
  createdAt: data.created_ts ? Number(data.created_ts) : null,
  teamAvailability: data.shared_with ? TeamAvailability.On : TeamAvailability.Off
});
export const fromBoard = board => {
  const [, id] = decodeBoardId(board.id);
  return {
    board_id: id,
    title: board.name,
    visibility: board.sitesVisibility || SitesVisibility.All,
    user_id: board.userId,
    site_id: board.siteId,
    description: board.description,
    cover_url: board.thumbnailUrl,
    created_ts: board.createdAt,
    team_shared: board.teamAvailability === TeamAvailability.On
  };
};